import React, { useState, useEffect } from "react";
import Header from "../NewHeader/NewHeaderPayLater";
import "./PaymentDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEuroSign } from "@fortawesome/free-solid-svg-icons";
import Collapsible from "react-collapsible";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import {
  getAgentCommissionDetails,
  getAgentDepositDetails,
  // getAccomadationBookingIdEJuniferData,
  getGeoInfo,
  getCustomerLogin,
} from "../axios";

import { useSelector, useDispatch } from "react-redux";
import { clearToCart, updateToCart } from "../../redux/actions/actions";
import { constant, displayDateFormat } from "../AdminPackageDetails/PackageShowcase/commonFunction";

function PaylaterCartDetails() {
  const dispatch = useDispatch();

  const [customerDetails, setcustomerDetails] = useState(
    localStorage.getItem("userDetails") || "abc"
  );
  // const newselectedData = useSelector((state) => state.cardItems.cardData);
  const selectedData = useSelector((state) => state.cardItems.cardData);

  const isPackageCart = selectedData.some(x => x.hasOwnProperty("package_id"));
  const { packageBasicDetails, customerPackageAfterDiscountAmount } = useSelector((state) => state.adminPackageCart);

  const [GuestCount, setGuestCount] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);

  const [Guest, setGuest] = useState([
    {
      title: "Mr",
      age: "1",
      FirstName: "",
      LastName: "",
      ErrorFirstName: false,
      ErrorLastName: false,
      mainID: "",
    },
  ]);

  const [country, setcountry] = useState("");
  const [country_code, setcountry_code] = useState("");
  const [currency, setcurrency] = useState("");
  const [ip_address, setip_address] = useState("");
  const [TransactionUUID, setTransactionUUID] = useState("");
  const [DisablePayNowButton, setDisablePayNowButton] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [TourDetails, setTourDetails] = useState("");
  const [TotalPrice, setTotalPrice] = useState(0);
  const [Commission, setCommission] = useState(0);
  const [Deposit, setDeposit] = useState(0);
  const [CommissionAmount, setCommissionAmount] = useState(0);
  const [FinalAmount, setFinalAmount] = useState(0);
  const [counter, setCounter] = React.useState(180);
  let customerArr = localStorage.getItem("userDetails");

  let CustomArr = JSON.parse(customerArr);

  let customer_id = CustomArr?.agent_id;
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const transaction = urlParams.get("transaction");
    setTransactionUUID(transaction);
    window.setTimeout(function () {
      setDisablePayNowButton(true);

      dispatch(clearToCart());
      const url = "/home";
      window.location.replace(url);
    }, 3 * 60 * 1000);

    // newselectedData.length > 0 &&
    //   Object.entries(newselectedData).map((reducdata, c) => {
    //     if (reducdata[1].profileactivity == "Accommodations") {
    //       if (reducdata[1].junifer != null) {
    //         getAccomadationBookingIdEJuniferData(
    //           reducdata[1].hotel_id,
    //           reducdata[1].hotelData,
    //           reducdata[1].rateplancode
    //         ).then(
    //           (result) => {
    //             result.map((item, key) => {
    //               var newDatareduxShow = {
    //                 tour_id: null,
    //                 dateselected: null,
    //                 tourImage: null,
    //                 number: null,
    //                 ratePlanId: null,
    //                 numberTraveler: null,
    //                 tourName: null,
    //                 tourOption: null,
    //                 tourLocation: null,
    //                 time: null,
    //                 price_type: null,
    //                 tour_operator_id: null,
    //                 profileactivity: "Accommodations",
    //                 overview: null,
    //                 hotel_id: reducdata[1].hotel_id,
    //                 propertyName: reducdata[1].propertyName,
    //                 hotelimage: reducdata[1].hotelimage,
    //                 startDate: reducdata[1].startDate,
    //                 endDate: reducdata[1].endDate,
    //                 guestCombination: reducdata[1].guestCombination,
    //                 property_source: reducdata[1].property_source,
    //                 rateplancode: reducdata[1].rateplancode,
    //                 cartvalue: reducdata[1].cartvalue,
    //                 hotelData: reducdata[1].hotelData,
    //                 roomcount: reducdata[1].roomcount,
    //                 adultcount: reducdata[1].adultcount,
    //                 childcount: reducdata[1].childcount,
    //                 junifer: reducdata[1].junifer,
    //                 price: reducdata[1].price,
    //                 taxfeeepercent: 0,
    //                 totalamountincluded: reducdata[1].totalamountincluded,
    //                 taxamount: 0,
    //                 bookingEjunifer: item,
    //                 checkin: reducdata[1].checkin,
    //                 checkout: reducdata[1].checkout,
    //                 propertydescription: reducdata[1].propertydescription,
    //                 propertylocation: reducdata[1].propertylocation,
    //                 singleamount: reducdata[1].singleamount,
    //                 typedata: reducdata[1].typedata,
    //                 roomname: reducdata[1].roomname,
    //                 roombooking: null,
    //                 accommodationtype: "ejunifer",
    //               };

    //               const CartData = newselectedData;
    //               let CartItems = [...CartData];
    //               CartItems.splice(c, 1);

    //               CartItems.splice(c, 0, newDatareduxShow);

    //               dispatch(clearToCart());

    //               setTimeout(() => {
    //                 dispatch(updateToCart(CartItems));
    //               }, 1000);
    //             });
    //           },
    //           
    //         );
    //       }
    //     }
    //   });

    getAgentCommissionDetails(customer_id).then(
      (data) => {
        if (data != "") {
          setCommission(data);
        }
      },
    );
    getAgentDepositDetails(customer_id).then(
      (data) => {
        if (data != "") {
          setDeposit(data);
        }
      },
    );

    setTourDetails(selectedData);

    const totalprice = selectedData.reduce(
      (amount, item) => item.totalamountincluded + amount,
      0
    );
    let commissionAmount = (parseInt(Commission) / 100) * totalprice;
    setCommissionAmount(commissionAmount);
    let FinalAmountData = totalprice - commissionAmount;
    setFinalAmount(FinalAmountData);
    setTotalPrice(totalprice);

    getGeoInfo().then(
      (data) => {
        setcountry(data.country_name);
        setcountry_code(data.country_calling_code);
        setcurrency(data.currency);
        setip_address(data.ip);
      },

    );
    let userData = localStorage.getItem("userDetails");

    if (userData != null) {
      let newData = JSON.parse(userData);
      getCustomerLogin(newData.email).then(
        (data) => {
          // // console.log(data);
          // setcustomerDetails(data);
          // let Verified = "";
          // if (data.verified == 1) {
          //   Verified = true;
          // }

          // const dataSearch = {
          //   first_name: data.first_name,
          //   last_name: data.last_name,
          //   email: data.email,
          //   country_code: data.country_code,
          //   verified: Verified,
          //   uid: data.id,
          // };

          // let JsonData = JSON.stringify(dataSearch);

          // localStorage.setItem("userDetails", JsonData);
          // this.setState({ customerDetails: data });
          setcustomerDetails(data);
          if (data.user == 'nouser') {
            let Verified = "";
            if (data.agent.verified == 1) {
              Verified = true;
            }

            const dataSearch = {
              first_name: data.agent.first_name,
              last_name: data.agent.last_name,
              email: data.agent.email,
              country_code: data.agent.country_code,
              verified: Verified,
              uid: data.agent.id,
              agent_id: data.agent.id,
            };

            let JsonData = JSON.stringify(dataSearch);

            localStorage.setItem("userDetails", JsonData);
          } else {
            let Verified = true;

            const dataSearch = {
              first_name: data.user.user_first_name,
              last_name: data.user.user_last_name,
              email: data.user.user_email,
              country_code: data.user.country_code,
              verified: Verified,
              uid: data.user.user_id,
              agent_id: data.agent.id,
            };

            let JsonData = JSON.stringify(dataSearch);

            localStorage.setItem("userDetails", JsonData);
          }
        },

      );
    }
    let result = [];
    selectedData.length > 0 &&
      Object.entries(selectedData).map((itemdata, j) => {
        if (itemdata[1].profileactivity != "Accommodations") {
          let numberTravelerNew = JSON.parse(itemdata[1].numberTraveler);
          setGuestCount(numberTravelerNew);
          if (itemdata[1].price_type == 1) {
            const adultCounter = numberTravelerNew.reduce(
              (a, v) => a + v.adultCounter * 1,
              0
            );
            const childCounter = numberTravelerNew.reduce(
              (a, v) => a + v.childCounter * 1,
              0
            );
            const youthCounter = numberTravelerNew.reduce(
              (a, v) => a + v.youthCounter * 1,
              0
            );
            const seniorCounter = numberTravelerNew.reduce(
              (a, v) => a + v.seniorCounter * 1,
              0
            );
            const infantCounter = numberTravelerNew.reduce(
              (a, v) => a + v.infantCounter * 1,
              0
            );

            const TotalCount =
              adultCounter * 1 +
              childCounter * 1 +
              youthCounter * 1 +
              seniorCounter * 1 +
              infantCounter * 1;
            for (var i = 0; i < TotalCount; i++) {
              result.push({
                title: "Mr",
                age: "1",
                FirstName: "",
                LastName: "",
                ErrorFirstName: false,
                ErrorLastName: false,
                mainID: j,
                indexid: i,
              });
            }
          } else {
            const groupCounter = 1;
            for (var i = 0; i < groupCounter; i++) {
              result.push({
                title: "Mr",
                age: "1",
                FirstName: "",
                LastName: "",
                ErrorFirstName: false,
                ErrorLastName: false,
                mainID: j,
                indexid: i,
              });
            }
          }
        } else {
          if (itemdata[1].typedata == "multiple") {
            const GuesttravellerCount = itemdata[1].cartvalue;
            const adultCounter = GuesttravellerCount.reduce(
              (a, v) => a + v.adultCounter * 1,
              0
            );
            const childCounter = GuesttravellerCount.reduce(
              (a, v) => a + v.childCounter * 1,
              0
            );
            setGuestCount(GuesttravellerCount);
            const TotalCount = adultCounter * 1 + childCounter * 1;
            for (var i = 0; i < TotalCount; i++) {
              result.push({
                title: "Mr",
                age: "1",
                FirstName: "",
                LastName: "",
                ErrorFirstName: false,
                ErrorLastName: false,
                mainID: j,
                indexid: i,
              });
            }
          } else {
            const GuesttravellerCount = itemdata[1].guestCombination;
            const adultCounter = GuesttravellerCount.reduce(
              (a, v) => a + v.adultCounter * 1,
              0
            );
            const childCounter = GuesttravellerCount.reduce(
              (a, v) => a + v.childCounter * 1,
              0
            );
            setGuestCount(GuesttravellerCount);
            const TotalCount = adultCounter * 1 + childCounter * 1;
            for (var i = 0; i < TotalCount; i++) {
              result.push({
                title: "Mr",
                age: "1",
                FirstName: "",
                LastName: "",
                ErrorFirstName: false,
                ErrorLastName: false,
                mainID: j,
                indexid: i,
              });
            }
          }
        }
      });
    let resultDate = [];
    selectedData.length > 0 &&
      Object.entries(selectedData).map((itemdata, j) => {
        if (itemdata[1]?.firstcancellationdate != "") {
          resultDate.push(itemdata[1]?.firstcancellationdate);
        }
      });
    setSelectedDate(resultDate);
    setGuest(result);
  }, []);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter])

  let ConfirmBooking = (e) => {
    e.preventDefault();

    let text =
      "Please confirm your details and amount of purchase before proceeding forward.";
    if (window.confirm(text) == true) {
      setDisablePayNowButton(true);
      setRedirect(true);
      dispatch(clearToCart());
      const url = "/paylaterdisplay.php/" + TransactionUUID;
      window.location.replace(url);
    }
  };
  let CancelBooking = (e) => {
    e.preventDefault();

    let text = "Are you sure you want to cancel this order.";
    if (window.confirm(text) == true) {
      setDisablePayNowButton(true);
      setRedirect(true);
      dispatch(clearToCart());
      const url = "/home";
      window.location.replace(url);
    }
  };

  const getTotalNumber = (item) => {
    if (item.profileactivity != "Accommodations") {
      const GuesttravellerCount = JSON.parse(item.numberTraveler);
      return (
        <>
          {item.price_type == 1 ? (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
                0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.adultCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Adults,&nbsp;
                  </>
                )}

              {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
                0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.childCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Children&nbsp;
                  </>
                )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.infantCounter * 1,
                0
              ) > 0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.infantCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Infant,&nbsp;
                  </>
                )}

              {GuesttravellerCount.reduce((a, v) => a + v.youthCounter * 1, 0) >
                0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.youthCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Youth,&nbsp;
                  </>
                )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.seniorCounter * 1,
                0
              ) > 0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.seniorCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Senior,&nbsp;
                  </>
                )}
            </>
          ) : (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.groupCounter * 1, 0) >
                0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.groupCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Travelers,&nbsp;
                  </>
                )}
            </>
          )}
        </>
      );
    } else {
      if (item.typedata == "multiple") {
        const GuesttravellerCount = item.cartvalue;

        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.adultCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Adults,&nbsp;
                </>
              )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.childCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Childs,&nbsp;
                </>
              )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.roomCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Room,&nbsp;
                </>
              )}
          </>
        );
      } else {
        const GuesttravellerCount = item.guestCombination;
        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.adultCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Adults,&nbsp;
                </>
              )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.childCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Childs,&nbsp;
                </>
              )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.roomCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Room,&nbsp;
                </>
              )}
          </>
        );
      }
    }
  };

  const displayPayment = () => {
    const TotalPrice = selectedData.reduce(
      (amount, item) => parseFloat(item.price) + amount,
      0
    );

    const TaxandFee = 0;
    let TotalPriceInclude = TaxandFee + TotalPrice;
    let CommissionPrice = (parseFloat(Commission) / 100) * TotalPriceInclude;
    let FinalPrice = parseFloat(TotalPriceInclude - CommissionPrice);

    return (
      <div class="pricing-details">
        <div className="price-breakup">
          <div className="price-header">
            <h4 className="font16 latoBlack blackText">Price Breakup</h4>
          </div>
          <div className="total-amount">
            <div>
              <p>Base Price</p>
            </div>
            <div>
              <p
                className="latoBlack font16 blackText appendBottom5"
                id="hlistpg_hotel_shown_price"
              >
                <span>€</span>
                {TotalPrice.toFixed(2)}
              </p>
            </div>
          </div>
          {/* <div className="taxes">
              <h6 style={{ color: "black" }}>
                TAX & FEES
              </h6>
              <h6 style={{ color: "black" }}> <span>€</span> {TaxandFee.toFixed(2)}</h6>
            </div> */}
          <div className="taxes">
            <h6 style={{ color: "black" }}>
              Less Agent Discount({Commission}%)
            </h6>
            <h6 style={{ color: "black" }}>
              <span>€</span>
              {CommissionPrice.toFixed(2)}{" "}
            </h6>
          </div>
          <div className="total-amount">
            <h6 style={{ color: "black" }}>Total Amount to be paid</h6>
            <h6 style={{ color: "red" }}>
              <FontAwesomeIcon
                icon={faEuroSign}
                style={{ fontSize: "14px", marginRight: "5px" }}
              ></FontAwesomeIcon>
              {FinalPrice.toFixed(2)}
            </h6>
          </div>
        </div>

        <div className="price-breakup" style={{ marginTop: "10%" }}>
          <div className="price-header">
            <h6 style={{ color: "black" }}>Our Bank Account Details </h6>
          </div>
          <div className="taxes">
            <div>
              <h6 style={{ color: "black" }}>
                Company Name: ESPACE (SEYCHELLES) LIMITED Trading as Holidays
                Seychelles
              </h6>
            </div>
          </div>

          <div className="taxes">
            <h6 style={{ color: "black" }}>
              Bank Name: Absa Bank (Seychelles) Limited
            </h6>
          </div>
          <div className="taxes">
            <h6 style={{ color: "black" }}>Bank Account Number: 010 7647864</h6>
          </div>
          <div className="taxes">
            <h6 style={{ color: "black" }}>Branch: Independence Avenue</h6>
          </div>
          <div className="taxes">
            <h6 style={{ color: "black" }}>SWIFT CODE: BARCSCSC</h6>
          </div>
          <div className="total-amount">
            <div>
              <p>IBAN CODE: SC02BARC01010000000107647864EUR</p>
            </div>
          </div>
        </div>
        <div style={{ padding: "15px 20px 15px 20px", marginTop: "10px" }}>
          <p>
            “When you press the confirm booking button all the booking items are
            confirmed with the supplier. You can go through the process of
            providing the vouchers to the clients. The bank transfer payment
            option itself will be manage offline.”
          </p>
          <button
            className="payLaterConfirmBooking"
            onClick={ConfirmBooking}
            disabled={DisablePayNowButton}
          >
            Confirm Booking
          </button>
        </div>
      </div>
    );
  };

  let TotalPriceNew = selectedData.reduce(
    (amount, item) => parseFloat(item.price) + amount,
    0
  );

  const TaxandFee = 0;
  let TotalPriceInclude = TaxandFee + TotalPriceNew;
  let CommissionPrice = (parseFloat(Commission) / 100) * TotalPriceInclude;
  let FinalPrice = parseFloat(TotalPriceInclude - CommissionPrice);

  let FirstPayment = (parseFloat(Deposit) / 100) * FinalPrice;
  let LastPayment = parseFloat(FinalPrice - FirstPayment);

  let CancellationModalAcco = (data, StartDate) => {
    let DataNew = "";
    let Value = "";
    let EuroIcon = "";
    let PerIcon = "";

    return (
      <>
        {" "}
        {data.map((i, index) => {
          const date = new Date(StartDate);
          date.setDate(date.getDate() - i.day_before_arrival);

          DataNew = moment(date).format("Do MMM YYYY");
          // if(i.day_before_arrival == 1 || i.day_before_arrival== 2){
          //   date.setDate(date.getDate() - i.day_before_arrival);
          //   DataNew = moment(date).format("Do MMM YYYY");
          //  }{

          //   date.setDate(date.getDate() - (i.day_before_arrival - 2));
          //    DataNew = moment(date).format("Do MMM YYYY");
          //   DataNew = "If cancelled or modified " + parseInt(i.day_before_arrival - 2) + " days before date of acccommodations.";
          //   DataNew = "If cancelled or modified " + moment(date).format("Do MMM YYYY") + " days before date of acccommodations.";
          // }
          if (i.penalty == "No Penalty") {
            // Value = 0;
            Value = 0;
            EuroIcon = "";
            PerIcon = "";
          } else if (i.penalty == "Full Amount") {
            // Value = 100;
            Value = "";
            EuroIcon = "";
            PerIcon = "Full booking amount will be charged.";
          } else if (i.penalty == "Percentage") {
            // Value = i.cancellation_value;
            Value = i.cancellation_value;
            EuroIcon = "";
            PerIcon = "% of booking amount will be charged.";
          } else if (i.penalty == "Nights") {
            //Value = i.cancellation_value;
            Value = i.cancellation_value;
            EuroIcon = <span>€</span>;
            PerIcon = " amount will be charged.";
          } else if (i.penalty == "Fixed Amount") {
            Value = i.cancellation_value;
            EuroIcon = <span>€</span>;
            PerIcon = " amount will be charged.";
          }

          if (i.day_before_arrival == -1) {
            DataNew = "No Show";
          }

          // if (id == i.rate_plan_id) {
          return (
            <div className="cncpolicyTbl__row">
              <div className="cncpolicyTbl__col">
                {index == 0 ? "Before" : "After"} &#x202A;{DataNew}&#x202C;
              </div>
              <div className="cncpolicyTbl__col">
                {/* Charge {Value}% of booking amount will be charged */}
                {EuroIcon} {Value}
                {PerIcon}
              </div>
            </div>
          );
          //}
        })}
      </>
    );
  };

  let getDateModalAcco = (data, StartDate) => {
    let DataNew = "";

    if (data[0].cancellation_penalty_id == 1) {
      const date = new Date(StartDate);
      date.setDate(date.getDate() - data[0].day_before_arrival);

      DataNew =
        "Free Cancellation(100% refund) if you cancel this booking before " +
        moment(date).format("Do MMM YYYY");
      //  DataNew ="Free Cancellation (100% refund) if you cancel this booking on or before start of accommodations.";
    } else if (data[0].cancellation_penalty_id == 3) {
      DataNew =
        "Minimum " +
        data[0].cancellation_value +
        "% cancellation charges applicable";
    }

    return DataNew;
  };

  let getDateModal = (data, dateSelected) => {
    let DataNew = "";

    //  const selectActivityDay = this.state.selectActivityDay;

    if (data[0].cancellation_penalty_id == 1) {
      const date = new Date(dateSelected);
      // date.setDate(date.getDate() - data[0].day_before_arrival);

      DataNew =
        "Free Cancellation (100% refund) if you cancel this booking on or before start of experience (tour, event, attraction, activity). ";
      // +moment(date).format("Do MMM YYYY");
    } else if (data[0].cancellation_penalty_id == 3) {
      DataNew =
        "Minimum " +
        data[0].cancellation_value +
        "% cancellation charges applicable";
    }

    return DataNew;
  };

  let CancellationModal = (data, dateSelected) => {
    let DataNew = "";
    let Value = "";
    let EuroIcon = "";
    let PerIcon = "";
    let ContentData = "";
    return (
      <>
        {" "}
        {data
          .slice(0)
          .reverse()
          .map((i, index) => {
            //const date = new Date();
            // const selectActivityDay = this.state.selectActivityDay;
            const date = new Date(dateSelected);
            if (i.day_before_arrival == 1 || i.day_before_arrival == 2) {
              date.setDate(date.getDate() - i.day_before_arrival);
              DataNew = moment(date).format("Do MMM YYYY");
            }
            {
              date.setDate(date.getDate() - (i.day_before_arrival - 2));
              // DataNew = moment(date).format("Do MMM YYYY");
              DataNew =
                "If cancelled or modified " +
                parseInt(i.day_before_arrival - 2) +
                " days before date of experience (tour, event, attraction, activity).";
            }

            if (i.penalty == "No Penalty") {
              Value = 0;
              EuroIcon = "";
              PerIcon = "";
            } else if (i.penalty == "Full Amount") {
              Value = "";
              EuroIcon = "";
              PerIcon = "Full booking amount will be charged";
            } else if (i.penalty == "Percentage") {
              Value = i.cancellation_value;
              EuroIcon = "";
              PerIcon = "% of booking amount will be charged ";
            } else if (i.penalty == "Nights") {
              Value = i.cancellation_value;
              EuroIcon = EuroIcon = <span>€</span>;
              PerIcon = " amount will be charged.";
            } else if (i.penalty == "Fixed Amount") {
              Value = i.cancellation_value;
              EuroIcon = <span>€</span>;
              PerIcon = " amount will be charged.";
            }

            if (i.day_before_arrival == 1) {
              DataNew = "In case of no show";
              //ContentData = "In case of "
            }

            //   if (id == i.rate_plan_id) {
            return (
              <div className="cncpolicyTbl__row">
                <div className="cncpolicyTbl__col">
                  {index == 0 ? "" : ""} &#x202A;{DataNew}&#x202C;
                </div>
                <div className="cncpolicyTbl__col">
                  {EuroIcon} {Value}
                  {PerIcon}
                </div>
              </div>
            );
            //   }
          })}
      </>
    );
  };

  return (
    <div>
      <Header />
      <div className="sticky-scroll topSection appendBottom40">
        <div className="review" style={{ height: "65px" }}>
          <div className="landingContainer">
            <h4>Pay later by Bank Transfer </h4>
          </div>
        </div>

        <div className="Details">
          <div className="landingContainer_details">
            <div className="subDetails">
              <div className="counterPaylater">
                <span style={{ color: "black" }}>Time Remaining: </span>{" "}
                {counter} Sec
              </div>
              <div className="GuestInfo" style={{ marginTop: 0 }}>
                <div className="upper-Scroll">
                  <h6 style={{ color: "black" }}>Your Payment Schedule </h6>
                </div>

                <div class="Container-Tile NewCartDetails">
                  <div class="Text-Section">
                    <div class="Text-Contents">
                      <div
                        class="Small-Text"
                        style={{
                          height: "100%",
                          overflow: "hidden",
                          marginLeft: "20px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#555",
                            marginTop: 8,
                            textAlign: "justify",
                            marginRight: 15,
                          }}
                        >
                          • {Deposit} % of the Booking Amount –{" "}
                          {FirstPayment.toFixed(2)} EURO on or before{" "}
                          {moment(
                            selectedDate.length > 0 &&
                            selectedDate.reduce(function (a, b) {
                              return a < b ? a : b;
                            })
                          )
                            .subtract(15, "day")
                            .format("D MMM Y")}
                          .
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#555",
                            marginTop: 8,
                            textAlign: "justify",
                            marginRight: 15,
                          }}
                        >
                          • Balance {100 - Deposit} % of the Booking Amount –{" "}
                          {LastPayment.toFixed(2)} EUR on or before{" "}
                          {moment(
                            selectedDate.length > 0 &&
                            selectedDate.reduce(function (a, b) {
                              return a < b ? a : b;
                            })
                          ).format("D MMM Y")}
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <form>
                {isPackageCart && <div
                  className="GuestInfo"
                  style={{ marginTop: 0 }}
                  key={"package"}
                >
                  <div className="upper-Scroll">
                    <h6 style={{ color: "black" }}>Package</h6>
                  </div>
                  <div class="Container-Tile NewCartDetails">
                    <div class="Image-Section me-3">
                      <span
                        class=" lazy-load-image-background  lazy-load-image-loaded"
                        style={{
                          display: "inlineBlock",
                          marginRight: 10,
                        }}
                      >
                        <img
                          src={packageBasicDetails?.package_image}
                          class="gallery__img"
                        />
                      </span>
                    </div>

                    <div class="Text-Section">
                      <div class="Text-Contents">
                        <div class="Text-Ratings">
                          <p class="txtHeading latoBlack font18 blackText">
                            <span>{packageBasicDetails?.package_name}</span>
                          </p>
                        </div>
                        <div className="Small-Text">
                          <p
                            style={{
                              fontSize: "12px",
                              color: "#000",
                              marginTop: 8,
                              textAlign: "justify",
                              marginRight: 15,
                            }}
                          >
                            {ReactHtmlParser(
                              `${packageBasicDetails?.package_description.substring(
                                0,
                                250
                              )}...`
                            )}
                          </p>
                        </div>
                      </div>
                      <div class="Text-Contents">
                        <div class="Small-Text">
                          <div
                            class="padding20 makeFlex column"
                            style={{ marginTop: " 0px" }}
                          >
                            <p
                              class="latoBlack font16 blackText appendBottom5"
                              id="hlistpg_hotel_shown_price"
                            >
                              {constant.amountWithCurrency(customerPackageAfterDiscountAmount)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="chkCont" style={{ marginTop: "-21px" }}>
                    <div class="chkCont__col">
                      <div class="paymakeFlex column">
                        <span class="font10 grayText appendBottom3">
                          CHECK IN
                        </span>
                        <span class="latoBlack font16 blackText appendBottom3">
                          {displayDateFormat(packageBasicDetails?.package_start_date)}
                        </span>
                      </div>
                      <div class="chkCont__night">
                        <span>{packageBasicDetails?.package_night} Nights</span>
                      </div>
                      <div class="paymakeFlex column">
                        <span class="font10 grayText appendBottom3">
                          CHECK OUT
                        </span>
                        <span class="latoBlack font16 blackText appendBottom3">
                          {displayDateFormat(packageBasicDetails?.package_end_date)}
                        </span>
                      </div>
                    </div>
                    <div class="chkCont__col">
                      <p
                        class="font16 blackText"
                        style={{ fontSize: "12px" }}
                      >
                        {packageBasicDetails?.package_guestCombination_sentence}
                      </p>
                    </div>
                  </div>
                </div>
                }
                <div>
                  {selectedData.length > 0 &&
                    Object.entries(selectedData.filter(x => !x.hasOwnProperty("package_id"))).map((itemdata, j) => {
                      if (itemdata[1].profileactivity != "Accommodations") {
                        return (
                          <div
                            className="GuestInfo"
                            style={{ marginTop: 0 }}
                            key={j}
                          >
                            <div className="upper-Scroll">
                              <h6 style={{ color: "black" }}>{itemdata[1].profileactivity}</h6>
                            </div>
                            <div class="Container-Tile NewCartDetails">
                              <div class="Image-Section me-3">
                                <span
                                  class=" lazy-load-image-background  lazy-load-image-loaded"
                                  style={{
                                    display: "inlineBlock",
                                    marginRight: 10,
                                  }}
                                >
                                  <img
                                    src={itemdata[1].tourImage}
                                    class="gallery__img"
                                  />
                                </span>
                              </div>
                              <div class="Text-Section">
                                <div class="Text-Contents">
                                  <div class="Text-Ratings">
                                    <p class="txtHeading latoBlack font18 blackText">
                                      <span>{itemdata[1].tourName}</span>
                                    </p>
                                  </div>
                                  <div className="Small-Text">
                                    {/* <p className="address" style={{ color: '#65cbf3' }}>
                                          {itemdata[1].tourLocation}
                                    </p> */}
                                    <p className="address" style={{ color: '#65cbf3' }}>
                                      {itemdata[1]?.pickuptransfer ? (`${itemdata[1]?.pickuptransfer} to ${itemdata[1]?.droptransfer}`) : (`${itemdata[1].tourLocation}`)}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        color: "#000",
                                        marginTop: 8,
                                        textAlign: "justify",
                                        marginRight: 15,
                                      }}
                                    >
                                      {itemdata[1].overview != "undefined" &&
                                        ReactHtmlParser(
                                          `${itemdata[1].overview.substring(
                                            0,
                                            170
                                          )}...`
                                        )}
                                    </p>

                                  </div>
                                </div>
                              </div>
                              {!itemdata[1].hasOwnProperty("package_id") && <div class="Text-Section">
                                <div class="Text-Contents">
                                  <div class="Small-Text">
                                    <div
                                      class="padding20 makeFlex column"
                                      style={{ marginTop: " 0px" }}
                                    >
                                      <p
                                        class="latoBlack font16 blackText appendBottom5"
                                        id="hlistpg_hotel_shown_price"
                                      >
                                        <span>€</span>
                                        {parseFloat(itemdata[1].price).toFixed(2)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>}
                            </div>
                            <div class="chkCont" style={{ marginTop: "-21px" }}>
                              <div class="chkCont__col">
                                <div class="paymakeFlex column">
                                  <span class="font10 grayText appendBottom3">
                                    DATE
                                  </span>
                                  <span class="latoBlack font16 blackText appendBottom3">
                                    {moment(itemdata[1].dateselected).format(
                                      "D MMM Y"
                                    )}
                                  </span>
                                </div>
                                <div class="chkCont__night">
                                  <span></span>
                                </div>
                                <div class="paymakeFlex column">
                                  <span class="font10 grayText appendBottom3">
                                    Time
                                  </span>
                                  <span class="latoBlack font16 blackText appendBottom3">
                                    {" "}
                                    {itemdata[1].time == "" ? (
                                      <> Coordinated Times</>
                                    ) : (
                                      <>{itemdata[1].time}</>
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div class="chkCont__col">
                                <p
                                  class="font16 blackText"
                                  style={{ fontSize: "12px" }}
                                >
                                  {getTotalNumber(itemdata[1])}
                                </p>
                              </div>
                            </div>
                            {itemdata[1].OfferName != "" &&
                              itemdata[1].OfferName?.offerName && (
                                <div
                                  class="title__placeHolder font12 pc__bottomBox"
                                  style={{ marginTop: 0 }}
                                >
                                  <div class="persuasion ">
                                    <div class="persuasion__item pc__cashbackDeal">
                                      <span class="sprite infoIconGreen"></span>
                                      <span>
                                        {itemdata[1].OfferName?.offerName}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}

                            <div
                              class="title__placeHolder font12 pc__bottomBox"
                              style={{ marginTop: 0 }}
                            >
                              {/* <div class="persuasion ">
                              <div class="persuasion__item pc__cashbackDeal">
                                <span class="sprite infoIconGreen"></span>

                                <div class="hsmakeFlex column flexOne appendLeft10">
                                  <p class="appendBottom4">
                                    <span class="greenText latoBold extraSpacing">
                                      Free Cancellation before{" "}
                                      {moment(
                                        itemdata[1].firstcancellationdate
                                      ).format("D MMM Y")}
                                    </span>
                                  </p>
                                  
                                </div>
                              </div>
                            </div> */}
                              <div
                                className="container"
                                style={{
                                  maxWidth: "1210px",
                                  marginBottom: 30,
                                  marginTop: 10,
                                }}
                              >
                                <Collapsible
                                  trigger="Policies"
                                  triggerClassName="txtHeading font22 latoBlack blackText textHeader"
                                  triggerOpenedClassName="txtHeading font22 latoBlack blackText textHeader"
                                  className="accordionCollapsed"
                                >
                                  {itemdata[1].cancellationpolicy != null &&
                                    itemdata[1].cancellationpolicy.cancellation_policy.map(
                                      (item, index) => {
                                        if (
                                          item[0].cancellation_penalty_id == 1
                                        ) {
                                          return (
                                            <div>
                                              <div className="latoRegular font16 appendBottom15">
                                                <b>
                                                  {getDateModal(
                                                    item,
                                                    itemdata[1]?.dateselected
                                                  )}
                                                  ‬&#x202C;
                                                </b>
                                              </div>
                                            </div>
                                          );
                                        } else {
                                          return (
                                            <>
                                              <div className="latoRegular font16 appendBottom15">
                                                <b>
                                                  The cancellation charges will be
                                                  applicable as follows
                                                </b>
                                              </div>
                                              <div className="cncpolicyTbl">
                                                <div className="cncpolicyTbl__head">
                                                  <div className="cncpolicyTbl__col">
                                                    Days Before Arrivals{" "}
                                                  </div>
                                                  <div className="cncpolicyTbl__col">
                                                    Charges{" "}
                                                  </div>
                                                </div>
                                                {CancellationModal(
                                                  item,
                                                  itemdata[1]?.dateselected
                                                )}
                                              </div>
                                            </>
                                          );
                                        }
                                      }
                                    )}

                                  {itemdata[1].cancellationpolicy != null &&
                                    itemdata[1].cancellationpolicy.cancellation_policy.map(
                                      (item, index) => {
                                        if (item[0].policy_text != null) {
                                          return (
                                            <>
                                              {" "}
                                              <section class="sectionWrapper">
                                                <h3 class="section-title">
                                                  More Details
                                                </h3>
                                                <div
                                                  class="description text-pre-wrap"
                                                  itemprop="description"
                                                >
                                                  {ReactHtmlParser(
                                                    item[0].policy_text
                                                  )}
                                                </div>
                                              </section>
                                            </>
                                          );
                                        }
                                      }
                                    )}
                                </Collapsible>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        let date1 = new Date(itemdata[1].startDate);
                        let date2 = new Date(itemdata[1].endDate);

                        let timeDiff = Math.abs(
                          date1.getTime() - date2.getTime()
                        );
                        let numberOfNights = Math.ceil(
                          timeDiff / (1000 * 3600 * 24)
                        );
                        return (
                          <div
                            className="GuestInfo"
                            style={{ marginTop: 0 }}
                            key={j}
                          >
                            <div className="upper-Scroll">
                              <h6 style={{ color: "black" }}>{itemdata[1].profileactivity}</h6>
                            </div>
                            <div class="Container-Tile NewCartDetails">
                              <div class="Image-Section me-3">
                                <span
                                  class=" lazy-load-image-background  lazy-load-image-loaded"
                                  style={{
                                    display: "inlineBlock",
                                    marginRight: 10,
                                  }}
                                >
                                  <img
                                    src={itemdata[1].hotelimage}
                                    class="gallery__img"
                                  />
                                </span>
                              </div>
                              <div class="Text-Section">
                                <div class="Text-Contents">
                                  <div class="Text-Ratings">
                                    <p class="txtHeading latoBlack font18 blackText">
                                      <span>{itemdata[1].propertyName}</span>
                                    </p>
                                  </div>
                                  <div className="Small-Text">
                                    <p className="address" style={{ color: '#65cbf3' }}>
                                      {itemdata[1].propertylocation}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        color: "#000",
                                        marginTop: 8,
                                        textAlign: "justify",
                                        marginRight: 15,
                                      }}
                                    >
                                      {itemdata[1].property_source == 1 ? (
                                        <>
                                          {ReactHtmlParser(
                                            `${itemdata[1].propertydescription.description.substring(
                                              0,
                                              170
                                            )}...`
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {ReactHtmlParser(
                                            `${itemdata[1].propertydescription.substring(
                                              0,
                                              170
                                            )}...`
                                          )}
                                        </>
                                      )}
                                    </p>

                                  </div>
                                </div>
                              </div>
                              {!itemdata[1].hasOwnProperty("package_id") && <div class="Text-Section">
                                <div class="Text-Contents">
                                  <div class="Small-Text">
                                    <div
                                      class="padding20 makeFlex column"
                                      style={{ marginTop: " 0px" }}
                                    >
                                      <p
                                        class="latoBlack font16 blackText appendBottom5"
                                        id="hlistpg_hotel_shown_price"
                                      >
                                        <span>€</span>
                                        {parseFloat(itemdata[1].price).toFixed(2)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>}
                            </div>
                            <div class="chkCont" style={{ marginTop: "-21px" }}>
                              <div class="chkCont__col">
                                <div class="paymakeFlex column">
                                  <span class="font10 grayText appendBottom3">
                                    CHECK IN
                                  </span>
                                  <span class="latoBlack font16 blackText appendBottom3">
                                    {moment(itemdata[1].startDate).format(
                                      "D MMM Y"
                                    )}
                                  </span>
                                  <span class="font10 grayText 444">
                                    {moment(itemdata[1].startDate).format("dddd")}
                                    , {itemdata[1].checkin}
                                  </span>
                                </div>
                                <div class="chkCont__night">
                                  <span>{numberOfNights} Nights</span>
                                </div>
                                <div class="paymakeFlex column">
                                  <span class="font10 grayText appendBottom3">
                                    CHECK OUT
                                  </span>
                                  <span class="latoBlack font16 blackText appendBottom3">
                                    {moment(itemdata[1].endDate).format(
                                      "D MMM Y"
                                    )}
                                  </span>
                                  <span class="font10 grayText">
                                    {" "}
                                    {moment(itemdata[1].endDate).format("dddd")},
                                    , {itemdata[1].checkout}
                                  </span>
                                </div>
                              </div>
                              <div class="chkCont__col">
                                <p
                                  class="font16 blackText"
                                  style={{ fontSize: "12px" }}
                                >
                                  {getTotalNumber(itemdata[1])}
                                </p>
                              </div>
                            </div>
                            <div class="rmDtl appendBottom15">
                              <div class="roomDtlCard">
                                <div class="roomDtlCard__head">
                                  <ul class="impInfoCard__list">
                                    {itemdata[1].junifer != null ? (
                                      <>
                                        {itemdata[1].junifer.HotelRooms.HotelRoom
                                          .length > 0 ? (
                                          <>
                                            {" "}
                                            {itemdata[1].junifer.HotelRooms.HotelRoom.map(
                                              (roomname, index) => (
                                                <>
                                                  <li>
                                                    <p
                                                      class="latoBlack font14 blackText"
                                                    // style={{
                                                    //   lineHeight: "25px",
                                                    // }}
                                                    >
                                                      {roomname.attributes.Units}{" "}
                                                      X {roomname.Name} (
                                                      {itemdata[1].junifer.Board})
                                                    </p>
                                                  </li>
                                                </>
                                              )
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <li>
                                              <p
                                                class="latoBlack font14 blackText"
                                              // style={{ lineHeight: "25px" }}
                                              >
                                                {
                                                  itemdata[1].junifer.HotelRooms
                                                    .HotelRoom.attributes.Units
                                                }{" "}
                                                X{" "}
                                                {
                                                  itemdata[1].junifer.HotelRooms
                                                    .HotelRoom.Name
                                                }{" "}
                                                ({itemdata[1].junifer.Board})
                                              </p>
                                            </li>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {itemdata[1].typedata == "multiple" ? (
                                          <>
                                            {itemdata[1].cartvalue.map(
                                              (cartitem, indexcart) => (
                                                <>
                                                  <li>
                                                    <p
                                                      class="latoBlack font14 blackText"
                                                      style={{
                                                        lineHeight: "25px",
                                                      }}
                                                    >
                                                      {cartitem.roomCounter} X{" "}
                                                      {cartitem.name}
                                                    </p>
                                                  </li>
                                                </>
                                              )
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <li>
                                              <p
                                                class="latoBlack font14 blackText"
                                                style={{ lineHeight: "25px" }}
                                              >
                                                1 X {itemdata[1].roomname}
                                              </p>
                                            </li>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            {itemdata[1].junifer != null &&
                              itemdata[1].junifer.HotelOfferName != "" ? (
                              <div class="title__placeHolder font12 pc__bottomBox">
                                <div class="persuasion ">
                                  <div class="persuasion__item pc__cashbackDeal">
                                    <span class="sprite infoIconGreen"></span>
                                    <span>
                                      {itemdata[1].junifer.HotelOfferName}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>
                                {itemdata[1].OfferName != "" &&
                                  itemdata[1].OfferName != "multipleOffer" ? (
                                  <div class="title__placeHolder font12 pc__bottomBox">
                                    <div class="persuasion ">
                                      <div class="persuasion__item pc__cashbackDeal">
                                        <span class="sprite infoIconGreen"></span>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    {" "}
                                    {itemdata[1].OfferName == "multipleOffer" &&
                                      itemdata[1].cartvalue.map(
                                        (cartitem, indexcart) => {
                                          if (cartitem.OfferData) {
                                            return (
                                              <>
                                                <div class="title__placeHolder font12 pc__bottomBox">
                                                  <div class="persuasion ">
                                                    <div class="persuasion__item pc__cashbackDeal">
                                                      <span class="sprite infoIconGreen"></span>
                                                      <span>
                                                        {
                                                          cartitem.OfferData[0]
                                                            .offerName
                                                        }
                                                        {itemdata[1].cartvalue
                                                          .length -
                                                          1 ===
                                                          indexcart
                                                          ? ""
                                                          : ","}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          }
                                        }
                                      )}
                                  </>
                                )}
                              </>
                            )}
                            <div
                              class="title__placeHolder font12 pc__bottomBox"
                              style={{ marginTop: 0 }}
                            >
                              {/* <div class="persuasion ">
                              <div class="persuasion__item pc__cashbackDeal">
                                <div class="hsmakeFlex column flexOne appendLeft10">
                                  <p class="appendBottom4">
                                    <span class="greenText latoBold extraSpacing">
                                      Free Cancellation before{" "}
                                      {moment(
                                        itemdata[1].firstcancellationdate
                                      ).format("D MMM Y")}
                                    </span>
                                  </p>
                                  <a
                                    class="OpenCancel"
                                    style={{ marginTop: 0 }}
                                   // onClick={openModalDiv(itemdata[1].cancellationpolicy)}
                                  >
                                    Read More
                                  </a>
                                </div>
                              </div>
                            </div> */}
                              <div
                                className="container"
                                style={{
                                  maxWidth: "1210px",
                                  marginBottom: 30,
                                  marginTop: 10,
                                }}
                              >
                                <Collapsible
                                  trigger="Policies"
                                  triggerClassName="txtHeading font22 latoBlack blackText textHeader"
                                  triggerOpenedClassName="txtHeading font22 latoBlack blackText textHeader"
                                  className="accordionCollapsed"
                                >
                                  {itemdata[1].junifer != null &&
                                    itemdata[1]?.junifer?.CancellationPolicy ? (
                                    <>
                                      <div className="latoRegular font16 appendBottom15">
                                        <b>
                                          Free Cancellation(100% refund) if you
                                          cancel this booking before &#x202A;
                                          {itemdata[1].junifer
                                            .CancellationPolicy &&
                                            itemdata[1].junifer.CancellationPolicy
                                              .PolicyRules.Rule.length > 0 &&
                                            moment(
                                              itemdata[1].junifer
                                                .CancellationPolicy.PolicyRules
                                                .Rule[0].attributes.DateTo
                                            ).format("Do MMM YYYY")}
                                          &#x202C;
                                          {/* Free Cancellation (100% refund) if you cancel this booking on or before start of accommodations */}
                                        </b>
                                      </div>
                                      <div>
                                        <div className="latoRegular font16 appendBottom15">
                                          <b>
                                            The cancellation charges will be
                                            applicable as follows
                                          </b>
                                        </div>
                                        {itemdata[1].junifer
                                          .CancellationPolicy && (
                                            <div className="cncpolicyTbl">
                                              <div className="cncpolicyTbl__head">
                                                <div className="cncpolicyTbl__col">
                                                  DATE
                                                </div>
                                                <div className="cncpolicyTbl__col">
                                                  FEE
                                                </div>
                                              </div>
                                              {itemdata[1].junifer
                                                .CancellationPolicy &&
                                                itemdata[1].junifer
                                                  .CancellationPolicy.PolicyRules
                                                  .Rule.length > 0 &&
                                                itemdata[1].junifer.CancellationPolicy.PolicyRules.Rule.map(
                                                  (data, index) => (
                                                    <div className="cncpolicyTbl__row">
                                                      <div className="cncpolicyTbl__col">
                                                        {index == 0
                                                          ? "Before"
                                                          : "After"}{" "}
                                                        &#x202A;
                                                        {index == 0
                                                          ? moment(
                                                            data.attributes.DateTo
                                                          ).format("Do MMM YYYY")
                                                          : moment(
                                                            data.attributes
                                                              .DateFrom
                                                          ).format(
                                                            "Do MMM YYYY"
                                                          )}
                                                        &#x202C;
                                                      </div>
                                                      <div className="cncpolicyTbl__col">
                                                        {
                                                          data.attributes
                                                            .PercentPrice
                                                        }
                                                        % of booking amount will be
                                                        charged
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                            </div>
                                          )}
                                      </div>
                                      <div>
                                        {itemdata[1].junifer
                                          .CancellationPolicy && (
                                            <div className="latoRegular font16 appendBottom15">
                                              Cancellations are only allowed before
                                              the Check-In Time. All time mentioned
                                              above is in Destination Time.
                                            </div>
                                          )}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {itemdata[1].cancellationpolicy != null &&
                                        itemdata[1].cancellationpolicy.map(
                                          (item, index) => {
                                            if (
                                              item[0].cancellation_penalty_id == 1
                                            ) {
                                              return (
                                                <div>
                                                  <div className="latoRegular font16 appendBottom15">
                                                    <b>
                                                      {getDateModalAcco(
                                                        item,
                                                        itemdata[1]?.startDate
                                                      )}
                                                      ‬&#x202C;
                                                    </b>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          }
                                        )}
                                      {itemdata[1].cancellationpolicy != null &&
                                        itemdata[1].cancellationpolicy.map(
                                          (item, index) => {
                                            return (
                                              <>
                                                <div className="latoRegular font16 appendBottom15">
                                                  <b>
                                                    The cancellation charges will
                                                    be applicable as follows
                                                  </b>
                                                </div>
                                                <div className="cncpolicyTbl">
                                                  <div className="cncpolicyTbl__head">
                                                    <div className="cncpolicyTbl__col">
                                                      DATE
                                                    </div>
                                                    <div className="cncpolicyTbl__col">
                                                      FEE
                                                    </div>
                                                  </div>

                                                  {CancellationModalAcco(
                                                    item,
                                                    itemdata[1]?.startDate
                                                  )}
                                                </div>

                                                <div className="latoRegular font16 appendBottom15">
                                                  Cancellations are only allowed
                                                  before the Check-In Time. All
                                                  time mentioned above is in
                                                  Destination Time.
                                                </div>
                                              </>
                                            );
                                          }
                                        )}
                                    </>
                                  )}
                                </Collapsible>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                </div>
              </form>
              <div style={{ padding: "15px 20px 15px 20px" }}>
                <p>
                  “When you press the confirm booking button all the booking
                  items are confirmed with the supplier. You can go through the
                  process of providing the vouchers to the clients. The bank
                  transfer payment option itself will be manage offline.”
                </p>
                <button
                  className="pay"
                  onClick={ConfirmBooking}
                  disabled={DisablePayNowButton}
                >
                  Confirm Booking
                </button>
                <button
                  className="pay"
                  onClick={CancelBooking}
                  disabled={DisablePayNowButton}
                >
                  Cancel
                </button>
              </div>

              {selectedData.length <= 0 ? (
                <>
                  {" "}
                  <div class="card"></div>
                </>
              ) : (
                <></>
              )}
            </div>

            {selectedData.length > 0 ? <>{displayPayment()}</> : <></>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaylaterCartDetails;
